import { render, staticRenderFns } from "./suppliers-performance-orders-chart.vue?vue&type=template&id=d0c51734&scoped=true&"
import script from "./suppliers-performance-orders-chart.vue?vue&type=script&lang=js&"
export * from "./suppliers-performance-orders-chart.vue?vue&type=script&lang=js&"
import style0 from "./suppliers-performance-orders-chart.vue?vue&type=style&index=0&id=d0c51734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c51734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c51734')) {
      api.createRecord('d0c51734', component.options)
    } else {
      api.reload('d0c51734', component.options)
    }
    module.hot.accept("./suppliers-performance-orders-chart.vue?vue&type=template&id=d0c51734&scoped=true&", function () {
      api.rerender('d0c51734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring/charts/suppliers-performance-orders-chart.vue"
export default component.exports